function getNodes (edges) {
  return edges.map(({ node }) => node)
}

export { getNodes }
